"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  AdditionalFiltersLayout: true
};
exports.AdditionalFiltersLayout = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("../../elements/button/Button");
var _additionalFiltersLayoutModule = _interopRequireDefault(require("./additional-filters-layout.module.scss"));
var _close = require("../../assets/icons/close.svg");
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var _AddFiltersToggle = require("./add-filters-toggle/AddFiltersToggle");
Object.keys(_AddFiltersToggle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _AddFiltersToggle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AddFiltersToggle[key];
    }
  });
});
var AdditionalFiltersLayout = function AdditionalFiltersLayout(_ref) {
  var applyFilters = _ref.applyFilters,
    resetFilters = _ref.resetFilters,
    hasFiltersApplied = _ref.hasFiltersApplied,
    children = _ref.children,
    visible = _ref.visible,
    hide = _ref.hide;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return visible ? /*#__PURE__*/_react.default.createElement("div", {
    className: _additionalFiltersLayoutModule.default['additional-filters'],
    "data-testid": "additional-filters"
  }, /*#__PURE__*/_react.default.createElement(_close.ReactComponent, {
    className: _additionalFiltersLayoutModule.default['additional-filters__close-icon'],
    "data-testid": "additional-filters-close",
    onClick: hide
  }), /*#__PURE__*/_react.default.createElement("h1", {
    className: _additionalFiltersLayoutModule.default['additional-filters__header']
  }, t('additionalFiltersLayout.filterBy')), /*#__PURE__*/_react.default.createElement("div", {
    className: _additionalFiltersLayoutModule.default['additional-filters__filters-list']
  }, children), /*#__PURE__*/_react.default.createElement("div", {
    className: _additionalFiltersLayoutModule.default['additional-filters__buttons']
  }, /*#__PURE__*/_react.default.createElement(_Button.PrimaryButton, {
    onClick: applyFilters,
    className: _additionalFiltersLayoutModule.default['additional-filters__button']
  }, t('additionalFiltersLayout.apply')), hasFiltersApplied && /*#__PURE__*/_react.default.createElement(_Button.LinkButton, {
    onClick: resetFilters,
    className: _additionalFiltersLayoutModule.default['additional-filters__button']
  }, /*#__PURE__*/_react.default.createElement(_close.ReactComponent, null), " ", t('additionalFiltersLayout.clear')))) : null;
};
exports.AdditionalFiltersLayout = AdditionalFiltersLayout;